import {DICT_KEY, getDictNameByCode, getModel, setModel} from "../../../utils/constants";
import ModelUtils from "../../../utils/ModelUtils";
import SaleOrderService from "./SaleOrderService";
import StockStatisticService from "../../stock/statistic/StockStatisticService";
import {v4 as uuidv4} from "uuid";

const MODEL_KEY = DICT_KEY.SALE_ORDER;
const storageModel = getModel(MODEL_KEY);

const initModel = {
    //查询参数
    searchParam: {},
    //单据列表
    documentList: [],
    //销售订单统计信息
    documentStatistic: {},
    //单据列表分页信息
    documentPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 15
    },
    //选中单据
    selectedDocument: {},
    //选中单据key数组
    selectedDocumentRowKeys: [],
    //单据打印窗口显示
    printDocumentModelVisible: false,
    detailStatistics: {
        //销售数量
        saleTotalNum: 0,
        //赠品总数量
        freeTotalNum: 0,
        //应收总金额
        receivableTotalAmount: 0,
        //商品金额
        saleTotalAmount: 0,
    },


    //单据配件列表
    documentMaterialList: [],
    //选中配件
    selectedDocumentMaterial: null,
    //选中配件key数组
    selectedDocumentMaterialRowKeys: [],


    //添加物料窗口显示
    addMaterialModelVisible: false,
    materialSearchParam: {},
    //待选配件列表
    materialList: [],
    materialPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 5
    },
    //已选配件列表
    selectedMaterialList: [],
    formExpand: false,
    formData: {},
    priceType: null
};
const cacheAble = false;
const saleOrderModel = {
    state: cacheAble && storageModel ? storageModel : initModel,
    reducers: {
        init(state,) {
            state = {...initModel};
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setPriceType(state, payload) {
            state.priceType = payload;
            state.documentMaterialList = [...state.documentMaterialList].map(el => {
                const {salePrice0, subSalesPrice} = el;
                return {
                    ...el,
                    salePrice: payload === "038001" ? salePrice0 ? salePrice0 : 0 : subSalesPrice ? subSalesPrice : 0
                }
            });
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        toggleExpand(state,) {
            state.formExpand = !state.formExpand;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setFormData(state, payload) {
            state.formData = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDetailStatistics(state, payload) {
            state.detailStatistics = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSearchParam(state, payload) {
            state.searchParam = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state.searchParam, ...state});
        },
        resetSearchParam(state) {
            state.searchParam = {};
            if (cacheAble) setModel(MODEL_KEY, state);
        },
        setDocumentList(state, payload) {
            state.documentList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDocumentStatistic(state, payload) {
            state.documentStatistic = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDocumentPageInfo(state, payload) {
            state.documentPageInfo = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedDocument(state, payload) {
            state.selectedDocument = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedDocumentRowKeys(state, payload) {
            state.selectedDocumentRowKeys = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setPrintDocumentModelVisible(state, payload) {
            state.printDocumentModelVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },

        setDocumentMaterialList(state, payload) {
            state.documentMaterialList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //添加单据中的配件信息
        addDocumentMaterial(state, payload) {
            state.documentMaterialList.push(...payload);
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //移除单据中的配件信息
        removeDocumentMaterial(state, payload) {
            state.documentMaterialList = state.documentMaterialList.filter(el => !!!payload.find(ele => ele === el.key));
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //设置单据中选中的配件
        setSelectedDocumentMaterial(state, payload) {
            state.selectedDocumentMaterial = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedDocumentMaterialRowKeys(state, payload) {
            state.selectedDocumentMaterialRowKeys = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },

        setAddMaterialModelVisible(state, payload) {
            state.addMaterialModelVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setMaterialSearchParam(state, payload) {
            state.materialSearchParam = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //待选配件列表
        setMaterialList(state, payload) {
            state.materialList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setMaterialPageInfo(state, payload) {
            state.materialPageInfo = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedMaterialList(state, payload) {
            state.selectedMaterialList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //添加已选配件
        addSelectedMaterial(state, payload) {
            // console.log(payload)
            // state.materialList = state.materialList.filter(el => el.id !== payload.id);
            state.selectedMaterialList.push(payload);
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //删除已选配件
        removeSelectedMaterial(state, payload) {
            // state.materialList.push(payload);
            state.selectedMaterialList = state.selectedMaterialList.filter(el => el.id !== payload.id);
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //选中库存列表转化为销售订单明细列表
        transSelectedStockItemListToOrderItemList(state,) {
            const {priceType} = state.formData;
            const mappedItems = state.selectedMaterialList.map(el => {
                const row = stockItemMapToOrderItem(el,priceType)
                const {isProtect, saleNum, giftsNum, salePrice, discount, discountPrice} = row;
                return {
                    ...row,
                    isProtect: isProtect === "1" || isProtect === true ? "1" : "0",
                    aggregateAmount: (salePrice * (saleNum - giftsNum) * discount / 100 - discountPrice).toFixed(2)
                };
            });
            state.documentMaterialList = [...state.documentMaterialList, ...mappedItems]
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },

        updateStatus(state, status) {
            state.selectedDocument = {...state.selectedDocument, ...status}
        },
    },
    effects: () => ({
        //加载单据列表
        async loadDocumentList({showMsg = true, duration = 5, data}) {
            const funName = "加载销售订单列表";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.findPage(data);
                const {list, statistics, ...page} = retData;
                const mappedList = list.map(el => ({
                    ...el,
                    key: el.id,
                    orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_ORDER_STATUS, el.orderStatus),
                    orderTypeName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_ORDER_TYPE, el.orderType),
                    invoiceTypeName: getDictNameByCode(DICT_KEY.CM_DICT.INVOICE_TYPE, el.invoiceType),
                }));
                this.setDocumentList(mappedList);
                this.setDocumentStatistic(statistics);
                const {pageNum = 1} = page;
                this.setDocumentPageInfo({...page, pageNum: pageNum === 0 ? 1 : pageNum});
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async loadOrder({showMsg = true, duration = 5, data}) {
            const funName = "加载销售订单详细信息";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.findByIdOrCode(data);
                const {details, ...order} = retData;
                const mappedList = details.map(el => ({
                    ...el,
                    key: el.id,
                    materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit)
                }))

                this.setSelectedDocument({
                    ...order,
                    orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_ORDER_STATUS, order.orderStatus),
                });
                this.setDocumentMaterialList(mappedList);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //导出销售订单
        async exportOrder({showMsg = false, duration = 5, data}) {
            const funName = "导出销售订单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.export(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)
        },
        //新增订单
        async insert({showMsg = true, duration = 5, data}) {
            const funName = "新增销售订单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.insert(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //修改订单
        async update({showMsg = true, duration = 5, data}) {
            const funName = "修改销售订单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.update(data);

                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //作废
        async disable({showMsg = true, duration = 5, data}) {
            const funName = "销售订单作废";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.disable(data);
                if (retData) {
                    this.updateStatus({
                        orderStatus: "014002",
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_ORDER_STATUS, "014002")
                    });
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //转销售单
        async shift({showMsg = true, duration = 5, data}) {
            const funName = "销售订单转销售单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.shift(data);
                if (retData) {
                    this.updateStatus({
                        orderStatus: "014003",
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_ORDER_STATUS, "014003")
                    });
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        //下载销售订单明细导入模板
        async downloadDetailTpl({showMsg = false, duration = 5, data}) {
            const funName = "下载销售订单明细导入模板";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.downloadDetailTpl(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)
        },
        //加载库存数据
        async loadStockData({showMsg = false, duration = 5, data = {pageSize: 5}}) {
            let retData = await StockStatisticService.findPage(data);
            const {list, statistic, ...pageInfo} = retData;
            const materialList = list.map(el => ({
                ...el,
                key: el.id,
                Num:1,
                materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit),
                materialBrandName: getDictNameByCode(DICT_KEY.CM_DICT.BRAND, el.materialBrand),
            }));
            this.setMaterialList(materialList);
            const {pageNum = 1} = pageInfo;
            this.setMaterialPageInfo({...pageInfo, pageNum: pageNum === 0 ? 1 : pageNum});

        }
    })
}
const stockItemMapToOrderItem = (el, priceType) => {
    console.log(el,priceType)
    const {
        id,
        materialId,
        materialCode,
        materialName,
        replaceNum,
        materialUnit,
        materialUnitName,
        groupCode,
        category,
        Num,
        salesPrice: salePrice0 = 0,
        subSalesPrice = 0,
        warehouseId = "空",
        warehouseName = "空",
        shelfId = "空",
        shelfCode = "空",
        inventoryNum,
    } = el;

    return {
        key: uuidv4(),
        id,
        "saleOrderId": null,
        materialId,
        materialCode,
        materialName,
        replaceNum,
        materialUnit,
        materialUnitName,
        groupCode,
        category: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_SORT, category, true),

        saleNum: Num,
        giftsNum: 0,
        salePrice: priceType === "038001" ? salePrice0 : subSalesPrice,//销售价
        salePrice0,//销售价
        subSalesPrice,//二级销价
        "discount": 100,//折扣
        "discountPrice": 0.00,//优惠金额
        "aggregateAmount": 0.00,//总计
        isProtect: "0",

        warehouseId,
        warehouseName,
        shelfId,
        shelfCode,
        inventoryNum,
        deliveryStatus: "0",
        detailsDesc: "空",


        // "deleteFlag": 0,
        // "createTime": "2020-08-18 09:58:12",
        // "updateTime": "2020-08-18 10:28:42",
        // "createUser": "业务员",
        // "updateUser": "tester",
    }
}
export default saleOrderModel;